import {
  CellClassParams,
  EditableCallbackParams,
  IRowNode,
  ITooltipParams,
  NewValueParams,
} from '@ag-grid-community/core';
import { Signal } from '@angular/core';

import { PivotSettings } from '@models/trial-attributes/trial-attributes';

import { AgActionsComponentParams } from '@shared/ag-components/ag-actions/ag-actions.component';
import { AgRawTooltipValue } from '@shared/components/ag-raw-tooltip/ag-raw-tooltip';
import {
  Currency,
  InvoicePrepaidCandidate,
  listBudgetAttributesQuery,
  listUserNamesWithEmailQuery,
} from '@shared/services/gql.service';
import { ArrElement, Maybe } from '@shared/utils/utils';

import {
  AdjustmentsToPrepaidErrorRow,
  AdjustmentsToPrepaidRow,
} from '../adjustments-to-prepaid.model';

export interface GridConfigOptions {
  budgetAttributes: listBudgetAttributesQuery[];
  checkError: (
    params: CellClassParams<AdjustmentsToPrepaidRow>,
    cause: ArrElement<AdjustmentsToPrepaidErrorRow['causes']>
  ) => boolean;
  currentOpenMonth: string;
  editMode: Signal<boolean>;
  flags: { journalEntryApManualClearing: boolean };
  getAuthor: (id: string) => listUserNamesWithEmailQuery;
  getCellClasses: (
    classes?: string[]
  ) => (params: CellClassParams<AdjustmentsToPrepaidRow>) => string[];
  invoiceOptions: InvoicePrepaidCandidate[];
  isAdmin: boolean;
  isCellEditable: (
    params: AgActionsComponentParams | EditableCallbackParams<AdjustmentsToPrepaidRow>
  ) => boolean;
  onCellValueChanged: (params: NewValueParams<AdjustmentsToPrepaidRow>) => void;
  pivotSettings: PivotSettings;
  recalculateCells: (params: NewValueParams<AdjustmentsToPrepaidRow>) => void;
  status?: string;
  tooltipValueGetter: (
    params: ITooltipParams<AdjustmentsToPrepaidRow>
  ) => AgRawTooltipValue | string;
  vendorCurrency: Currency;
}

export const isTotalRow = <T extends { node: Maybe<IRowNode> }>(params: T) => {
  return !!params.node?.isRowPinned();
};
